import { MyAccountEditFormModel } from '@pages/my-account/my-account-edit/model/my-account-edit-form.model';
import { AuthUser } from '@core/domain/model/user/auth-user.model';
import { UserRequestApi } from '@core/api/model/user/user-request-api.model';

export class MyAccountMapper {
  static domainModelToApiBody(domain: MyAccountEditFormModel, authUser: AuthUser): UserRequestApi {
    return {
      nombre: domain.firstName,
      apellidos: domain.lastName,
      email: domain.email,
      telefono: domain.phone,
      avisoDisponibilidad: authUser.invoiceNotice,
      idHashCRM: authUser.crmCode,
    };
  }
}
